<template>
  <span
    :class="[
      'difficulty_tag',
      getDifficultyClass(difficulty)
    ]"
  >
    {{ getDifficultyName(difficulty) }}
    <i
      v-if="difficulty == null"
      class="fas fa-spinner fa-spin"
    />
  </span>
</template>

<script>
export default {
  props: {
    difficulty: {
      type: [Number, null],
      required: true,
    },
    tiers: {
      type: Object,
      default() {
        return {
          low: 39,
          med: 54,
          high: 74,
          vHigh: 100,
        }
      },
      validator(value) {
        return ['low', 'med', 'high', 'vHigh',].every(prop => Object.keys(value).includes(prop));
      }
    },
  },
  methods: {
    getDifficultyClass(difficulty) {
      if (difficulty == null) return 'fetching_data';
      if (difficulty <= this.tiers.low) return 'low';
      if (difficulty <= this.tiers.med) return 'medium';
      if (difficulty <= this.tiers.high) return 'high';
      if (difficulty <= this.tiers.vHigh) return 'very_high';
    },
    getDifficultyName(difficulty) {
      if (difficulty == null) return 'Fetching data';
      if (difficulty <= this.tiers.low) return 'Low';
      if (difficulty <= this.tiers.med) return 'Medium';
      if (difficulty <= this.tiers.high) return 'High';
      if (difficulty <= this.tiers.vHigh) return 'Very High';
    },
  }
}
</script>

<style lang="scss" scoped>

.difficulty_tag {
  width: fit-content;
  padding: 0.25rem 0.5rem;
  font-size: 10px;
  line-height: 1.3;
  letter-spacing: -0.1px;
  border-radius: 6px;
  margin: 2px;

  &.fetching_data {
    background-color: var(--tertiary-label-color);
    color: var(--tertiary-color);
  }

  &.low {
    background-color: var(--difficulty-low-color);
    color: var(--difficulty-low-font-color);
  }

  &.medium {
    background-color: var(--difficulty-medium-color);
    color: var(--difficulty-medium-font-color);
  }

  &.high {
    background-color: var(--difficulty-high-color);
    color: var(--difficulty-high-font-color);
  }

  &.very_high {
    background-color: var(--difficulty-very-high-color);
    color: var(--difficulty-very-high-font-color);
  }
}

</style>
